import { Core } from "./src/core"
import { lerp, damp, symmetricMod } from "./src/utils"

export default Core
export { lerp, damp, symmetricMod }
